import { motion } from "framer-motion";
import { Link } from "react-router-dom";

/** Hero strip used at the top of every internal page. Editorial section header. */
export default function PageHero({ eyebrow, title, italic, blurb, breadcrumb = "Home" }) {
  return (
    <section className="pt-12 pb-16 sm:pt-16 sm:pb-20 border-b border-[#0B1215]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          className="font-mono-label mb-6 flex items-center gap-3 text-[#495057]"
        >
          <Link to="/" className="hover:text-[#FF5A36] transition-colors">
            {breadcrumb}
          </Link>
          <span>/</span>
          <span className="text-[#FF5A36]">{eyebrow}</span>
        </motion.div>
        <motion.h1
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55, delay: 0.1 }}
          className="font-display text-5xl sm:text-6xl lg:text-7xl text-[#0B1215] tracking-tighter leading-[0.95]"
        >
          {title}
          {italic && (
            <>
              <br />
              <span className="italic font-light">{italic}</span>
            </>
          )}
        </motion.h1>
        {blurb && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.25 }}
            className="mt-6 text-[#495057] text-base sm:text-lg leading-relaxed max-w-2xl"
          >
            {blurb}
          </motion.p>
        )}
      </div>
    </section>
  );
}
